import React, { useEffect, useRef } from 'react';

const WeatherWidget = () => {
  const widgetRef = useRef(null);

  useEffect(() => {
    if (widgetRef.current) {
      const scriptContent = `
        (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (!d.getElementById(id)) {
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://app3.weatherwidget.org/js/?id=ww_e7cc644d79df8';
            fjs.parentNode.insertBefore(js, fjs);
          } else if (window.__weatherwidget_init) {
            window.__weatherwidget_init();
          }
        })(document, 'script', 'weatherwidget-io-js');
      `;
      const script = document.createElement('script');
      script.async = true;
      script.innerHTML = scriptContent;
      widgetRef.current.appendChild(script);
    }
  }, []);

  return (
    <div className="weather-widget-container">
      <div className="weather-widget" ref={widgetRef}>
      <div id="ww_e7cc644d79df8" v='1.3' loc='auto' a='{"t":"ticker","lang":"es","sl_lpl":1,"ids":[],"font":"Arial","sl_ics":"one_a","sl_sot":"celsius","cl_bkg":"#FFFFFF00","cl_font":"rgba(255,255,255,1)","cl_cloud":"#d4d4d4","cl_persp":"#2196F3","cl_sun":"#FFC107","cl_moon":"#FFC107","cl_thund":"#FF5722"}'>
      Más previsiones: <a href="https://oneweather.org/es/seville/25_days/" id="ww_e7cc644d79df8_u" target="_blank">El tiempo en Sevilla 25 días</a>
        </div>
      </div>
    </div>
  );
};

export default WeatherWidget;